import React, { ComponentType } from "react";

import { NavLink } from "react-router-dom";
import { ReactComponent as RightIcon } from "shared/assets/Icons/right.svg";
import classNames from "classnames";

type AccountNavLinkProps = {
  to: string;
  text: string;
  Icon: ComponentType<React.SVGProps<SVGSVGElement>>;
  bottomLine?: boolean;
};

type AccountNavItemProps = Omit<AccountNavLinkProps, "to">;

type AccountNavButtonProps = {
  onClick: () => void;
} & Omit<AccountNavLinkProps, "to">;

function AccountNavItem({ text, Icon, bottomLine = false }: AccountNavItemProps) {
  return (
    <div
      className={classNames("flex flex-row p-2 border-t border-border-grey align-middle justify-between", { "border-b": bottomLine })}
    >
      <div className={"flex flex-row"}>
        <div className={"flex justify-center items-center [&>*]:h-auto"}>
          <Icon className="w-6 h-full shrink-0 text-grey" />
        </div>
        <h3 className="p-2">{text}</h3>
      </div>
      <div className={"flex justify-center items-center"}>
        <RightIcon className="ml-auto text-border-grey" />
      </div>
    </div>
  );
}

export const AccountNavLink = ({ to, text, Icon, bottomLine }: AccountNavLinkProps) => {
  return (
    <NavLink to={to} className="no-underline">
      <AccountNavItem text={text} bottomLine={bottomLine} Icon={Icon} />
    </NavLink>
  );
};

export const AccountNavButton = ({ text, Icon, bottomLine, onClick }: AccountNavButtonProps) => {
  return (
    <button className="w-full" onClick={onClick}>
      <AccountNavItem text={text} bottomLine={bottomLine} Icon={Icon} />
    </button>
  );
};
